import { SysClientReportType } from 'app/core/models/sys-client-report-types.model';
import { SysContractStatusChangeReason } from 'app/core/models/sys-contract-status-change-reason.model';
import { SysContractStatus } from 'app/core/models/sys-contract-status.model';
import { SysFlightCardComponentType } from 'app/core/models/sys-flight-card-component-type.model';
import { ContractBillingEntity } from 'app/features/contracts/models/contract-billing-entity.model';
import { ContractFlightCardComponent } from 'app/features/contracts/models/contract-flight-card-component.model';
import { Contract, initialContract } from 'app/features/contracts/models/contract.model';
import { SysFlightCardComponent } from 'app/features/contracts/models/sys-flight-card.component.model';
import { AdminStaff } from 'app/features/manage/models/admin-staff.model';
import { ContractCaptureType } from 'app/features/settings/models/contract-capture-type.model';
import { ContractGroupType } from 'app/features/settings/models/contract-group-type.model';
import { ContractProgram } from 'app/features/settings/models/contract-program.model';
import { RateEscalationType } from 'app/features/settings/models/rate-escalation-type.model';
import { ContractTransfer } from 'app/features/contracts/models/contract-transfer.model';
import { Product } from 'app/features/settings/models/product.model';
import { ContractEntity } from 'app/features/contracts/models/contract-entity.model';
import { ContractGroupingForAnalytics } from 'app/features/settings/models/contract-grouping-for-analytics.model';
import { NextFlightCard } from 'app/features/contracts/models/next-flight-card.model';
import { ContractProduct } from 'app/features/contracts/models/contract-product.model';

export interface ContractState {
  contracts: Contract[]; // TO DO unused but can be tied to state later based on requirements
  searchedContracts: Contract[];
  contractGroupTypes: ContractGroupType[];
  contractPrograms: ContractProgram[];
  contractCaptureTypes: ContractCaptureType[];
  currentContract: Contract;
  addedContractId?: number;
  currentContractFlightCardComponents: ContractFlightCardComponent[];
  sysFlightCardComponents: SysFlightCardComponent[];
  sysFlightCardComponentTypes: SysFlightCardComponentType[];
  loading: boolean;
  error: string;
  rateEscalationTypes: RateEscalationType[];
  contractBillingEntities: ContractBillingEntity[];
  contractEntities: ContractEntity[];
  popupTitle: string;
  contractGroupingAnalytics: ContractGroupingForAnalytics[];
  contractProducts: ContractProduct[];
  contractProductShortNames: string;
  nextFlightCards: NextFlightCard[];
  regionalSaleManagerStaffs: AdminStaff[];

  // Lists to manage throughtout to reduce API calls
  adminStaffs: AdminStaff[];
  sysContractStatuses: SysContractStatus[];
  sysContractStatusChangeReasons: SysContractStatusChangeReason[];
  contractTransfers: ContractTransfer[];
  sysClientReportTypes: SysClientReportType[];
  products: Product[];
}

export const initialContractState: ContractState = {
  contracts: [],
  searchedContracts: [],
  contractGroupTypes: [],
  contractPrograms: [],
  contractCaptureTypes: [],
  currentContract: initialContract,
  addedContractId: undefined,
  currentContractFlightCardComponents: [],
  loading: false,
  error: '',
  sysFlightCardComponents: [],
  sysFlightCardComponentTypes: [],
  rateEscalationTypes: [],
  contractBillingEntities: [],
  contractEntities: [],
  popupTitle: '',
  adminStaffs: [],
  sysContractStatuses: [],
  sysContractStatusChangeReasons: [],
  contractTransfers: [],
  sysClientReportTypes: [],
  products: [],
  contractGroupingAnalytics: [],
  contractProductShortNames: '',
  contractProducts: [],
  nextFlightCards: [],
  regionalSaleManagerStaffs: [],
};
